export default "__VITE_ASSET__Beiac9I___"